import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import { setRootValue } from 'v2/modules/withRunForm/redux/actions';
import { ORDER_TYPES } from 'v2/common/constants/index';
import { onChangeOrderType } from 'v2/modules/withRunForm/events/orderType';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton/index';
import { OrderType as OrderTypeMap } from './types';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

type OrderValue = OrderTypeMap[keyof OrderTypeMap]['value'];

const OrderType = () => {
  const dispatch = useDispatch();

  //Todo: Remove this when we have a better solution for types
  const useUnsafeSelector = (key: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return useSelector((state) => getSelectorBasedStoreValue(state, key));
  };

  const orderType = useUnsafeSelector('orderType');
  const runType = useUnsafeSelector('runType');
  const quantConfig = useUnsafeSelector('quantConfig');
  const isStrategyAuthor = useUnsafeSelector('isStrategyAuthor');

  const onUpdateOrderType = (value: OrderValue) =>
    dispatch(
      setRootValue(
        onChangeOrderType({
          quantConfig,
          orderType: value,
          runType,
          isStrategyAuthor,
        })
      )
    );

  const allowedOrderTypes = _.filter(ORDER_TYPES, (type) =>
    ApplicationDomainUtility.eligibleOrderType().includes(type.value)
  );

  const toggleOptions = _.map(allowedOrderTypes, (type) => {
    const { value, displayName } = type;
    return {
      value,
      label: displayName,
      onClick: () => onUpdateOrderType(value as OrderValue),
      shouldShow: value !== ORDER_TYPES.oneClick.value,
    };
  });

  return (
    <div className="order-type-input d-grid">
      <label className="label_style mb-1">Order Type</label>
      <ToggleGroupButton
        options={toggleOptions}
        defaultValue={orderType}
        // isQubit ? 'flattrade' : ''
        containerClassName={ApplicationDomainUtility.isAlgoverse ? 'upstox' : ''}
      />
    </div>
  );
};

export default OrderType;
